import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import { Switch } from 'pretty-checkbox-react';
import useForm from 'react-hook-form';
/* actions */
import { getAllDepartments } from '../../redux/actions/departments';
import { addStatus } from '../../redux/actions/status';
/* components */
import ErrorMsgField from '../../components/ErrorMsgField';
import AlertMsg from '../../components/AlertMsg';
import FormFooter from '../../components/FormFooter';
import FormHeader from '../../components/FormHeader';
/* form-validation */
import schema from '../../form-validation/status';
/* utils */
import {
  customStyle,
  customThemes,
  firstOption,
  handleChangeSelect
} from '../../utils/select';
import sortable from '../../utils/sortable';
import handleChangeDefault from '../../utils/handleChangeDefault';
/* others */
import icons from './icons';

function Add () {
  const INITIAL_VALUES = {
    name: '',
    department: '',
    description: '',
    icon: '',
    isProductive: false
  };
  const dispatch = useDispatch();
  const submitButton = useRef();
  const { register, handleSubmit, errors, reset, setValue, setError } = useForm(
    {
      validationSchema: schema,
      reValidateMode: 'onSubmit'
    }
  );
  const departments = useSelector(state => state.departments);
  const status = useSelector(state => state.status);
  const [data, setData] = useState(INITIAL_VALUES);
  const [options, setOptions] = useState([firstOption]);

  useEffect(() => {
    dispatch(getAllDepartments());
  }, [dispatch]);

  useEffect(() => {
    const options = icons
      .map(icon => {
        return {
          value: icon.value,
          sortValue: icon.label,
          label: (
            <span>
              &nbsp;
              <i className={icon.value} />
              &nbsp;{icon.label}
            </span>
          )
        };
      })
      .sort(sortable);

    setOptions([...options]);
  }, []);

  const submit = () => {
    const resetForm = () => {
      reset();
      setData({ ...INITIAL_VALUES });
    };
    dispatch(addStatus(data, resetForm, submitButton.current));
  };

  return (
    <div className="container-fluid">
      {status.addSuccess && (
        <AlertMsg type="success" msg="Status cadastrado com sucesso" />
      )}
      {status.errorContent &&
        !status.errorContent.message.includes('400') &&
        status.addError && (
        <AlertMsg type="danger" msg="Falha durante cadastro do status" />
      )}
      {status.errorContent &&
        status.errorContent.message.includes('400') &&
        status.addError && (
        <AlertMsg
          type="danger"
          msg="Um status com o nome informado já está cadastrado"
        />
      )}
      {!status.addSuccess && !status.addError && (
        <AlertMsg type="info" msg="Área cadastro de status" />
      )}
      <FormHeader title="Cadastrar Status" />
      <form onSubmit={handleSubmit(submit)}>
        <div className="form-group">
          <label htmlFor="name">
            Nome<span className="field-required">*</span>
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            autoComplete="off"
            value={data.name}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          />
          {errors.name && errors.name.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="form-group">
          <label htmlFor="department">
            Departamento<span className="field-required">*</span>
          </label>
          <select
            className="form-control"
            id="department"
            name="department"
            value={data.department}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          >
            <option value="">-- Selecione --</option>
            {departments.data.map((dpt, i) => {
              const _id = dpt._id || Date.now() + '' + i;
              return (
                <option key={_id} value={_id}>
                  {dpt.name}
                </option>
              );
            })}
          </select>
          {errors.department && errors.department.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <div className="row">
          <div className="col-sm-5 col-md-3">
            <div className="form-group">
              <label htmlFor="isProductive">
                Tipo de Pausa<span className="field-required">*</span>
              </label>
              <div className="checkbox">
                <Switch
                  type="checkbox"
                  color="success"
                  name="isProductive"
                  checked={data.isProductive}
                  onChange={evt => {
                    setData({
                      ...data,
                      [evt.target.name]: evt.target.checked
                    });
                  }}
                >
                  {data.isProductive ? 'Produtiva' : 'Improdutiva'}
                </Switch>
              </div>
            </div>
          </div>
          <div className="col-sm-7 col-md-9">
            <div className="form-group">
              <label htmlFor="icon">
                Ícone<span className="field-required">*</span>
              </label>
              <Select
                name="icon"
                value={options.find(opt => opt.value === data.icon)}
                ref={register}
                onChange={evt =>
                  handleChangeSelect(
                    { ...evt, name: 'icon' },
                    data,
                    setData,
                    setError,
                    setValue
                  )
                }
                options={options}
                isSearchable={false}
                theme={customThemes}
                styles={customStyle}
              />
              {errors.icon && errors.icon.type === 'required' && (
                <ErrorMsgField type="required" />
              )}
            </div>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="description">
            Descrição<span className="field-required">*</span>
          </label>
          <textarea
            className="form-control"
            id="description"
            name="description"
            rows="3"
            value={data.description}
            onChange={evt => handleChangeDefault(evt, data, setData)}
            ref={register}
          ></textarea>
          {errors.description && errors.description.type === 'required' && (
            <ErrorMsgField type="required" />
          )}
        </div>
        <FormFooter url="/status" reference={submitButton} />
      </form>
    </div>
  );
}

export default Add;
